var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogout = function SvgLogout(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8039 8.60944L12.4722 7.27778L7.75 12L12.4722 16.7222L13.8039 15.3906L11.3672 12.9444L20.5 12.9444L20.5 11.0556L11.3672 11.0556L13.8039 8.60944ZM5.38889 20.5L18.6111 20.5C19.6594 20.5 20.5 19.65 20.5 18.6111L20.5 14.8333L18.6111 14.8333L18.6111 18.6111L5.38889 18.6111L5.38889 5.38889L18.6111 5.38889L18.6111 9.16667L20.5 9.16667L20.5 5.38889C20.5 4.35 19.6594 3.5 18.6111 3.5L5.38889 3.5C4.35 3.5 3.5 4.35 3.5 5.38889L3.5 18.6111C3.5 19.65 4.35 20.5 5.38889 20.5Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogout);
export default ForwardRef;